import { apiClient } from "./api-client";
import type {
  CreateWishRequest,
  DeleteWishResponse,
  OwnerWish,
  UpdateWishRequest,
  WishListItem,
  WishPreview,
  WishResponse,
} from "../types/wish";

interface ApiResponse<T> {
  data: T;
}

export function createWish(
  memberId: string,
  body: CreateWishRequest
): Promise<WishResponse> {
  return apiClient
    .post<ApiResponse<WishResponse>>(`/members/${memberId}/wishes`, body)
    .then((res) => res.data);
}

export function previewWish(url: string, signal?: AbortSignal): Promise<WishPreview> {
  return apiClient
    .post<ApiResponse<WishPreview>>("/wishes/preview", { url }, signal)
    .then((res) => res.data);
}

export function getWish(id: string): Promise<WishResponse> {
  return apiClient
    .get<ApiResponse<WishResponse>>(`/wishes/${id}`)
    .then((res) => res.data);
}

export function getMemberWishes(memberId: string): Promise<WishListItem[]> {
  return apiClient
    .get<ApiResponse<WishListItem[]>>(`/members/${memberId}/wishes`)
    .then((res) => res.data);
}

export function reorderWishes(memberId: string, wishIds: string[]): Promise<void> {
  return apiClient
    .put<ApiResponse<{ reordered: true }>>(`/members/${memberId}/wishes/order`, {
      wish_ids: wishIds,
    })
    .then(() => undefined);
}

export function updateWish(
  id: string,
  body: UpdateWishRequest,
): Promise<OwnerWish> {
  return apiClient
    .patch<ApiResponse<OwnerWish>>(`/wishes/${id}`, body)
    .then((res) => res.data);
}

export function deleteWish(id: string): Promise<DeleteWishResponse> {
  return apiClient
    .delete<ApiResponse<DeleteWishResponse>>(`/wishes/${id}`)
    .then((res) => res.data);
}
